import { MyRouterContext } from '@app/router';
import { createRootRouteWithContext } from '@tanstack/react-router';
import RootLayout from './-layouts/root-layout';

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: RootLayout,
});
